import { createAction, props } from '@ngrx/store';
import { AppStateFailure } from '@symphony-solo/shared/common-state/src';
import { TransactionReceiptResponseDto } from '../dtos';

export enum TransactionReceiptActionTypes {
  GetTransactionReceipt = '[TransactionReceip] GetTransactionReceipt',
  GetTransactionReceiptSuccess = '[TransactionReceip] GetTransactionReceiptSuccess',
  GetTransactionReceiptError = '[TransactionReceip] GetTransactionReceiptError',
}

export const getTransactionReceiptAction = createAction(TransactionReceiptActionTypes.GetTransactionReceipt, props<{ seq: number }>());

export const getTransactionReceiptSuccessAction = createAction(
  TransactionReceiptActionTypes.GetTransactionReceiptSuccess,
  props<{ transactionReceipt: Array<TransactionReceiptResponseDto> }>()
);

export const getTransactionReceiptErrorAction = createAction(
  TransactionReceiptActionTypes.GetTransactionReceiptError,
  props<{ failures: AppStateFailure }>()
);
